import { useQuery } from '@tanstack/react-query';

import searchImages from '../api/searchImages';

const useImageSearch = (query: string | undefined) => {
  return useQuery({
    queryKey: ['image-search', query],
    queryFn: () => searchImages(query!, 24),
    enabled: !!query && query.trim().length > 0
  });
};

export default useImageSearch;
